import { useEffect } from "react";
import { useBusiness } from "@/context/BusinessContext";

/** Injects per-business CSS variables + a Google Fonts link tag based on
 * `business.theme`. Mounts once near the root so every page picks them up. */
export default function ThemeInjector() {
  const { business } = useBusiness();
  const theme = business?.theme;

  useEffect(() => {
    if (!theme) return;
    const root = document.documentElement;
    const map = {
      "--biz-primary": theme.primary,
      "--biz-accent":  theme.accent,
      "--biz-surface": theme.surface,
      "--biz-ink":     theme.ink,
      "--biz-muted":   theme.muted,
      "--biz-serif":   `"${theme.serif_font}", Georgia, serif`,
      "--biz-sans":    `"${theme.sans_font}", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`,
    };
    Object.entries(map).forEach(([k, v]) => v && root.style.setProperty(k, v));

    // Inject Google Fonts <link> for the active pair (idempotent)
    const family = (s) => s.replaceAll(" ", "+");
    const href =
      `https://fonts.googleapis.com/css2?family=${family(theme.serif_font)}:wght@400;500;700&` +
      `family=${family(theme.sans_font)}:wght@300;400;500;600;700&display=swap`;
    let link = document.getElementById("biz-font-link");
    if (!link) {
      link = document.createElement("link");
      link.id = "biz-font-link";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    if (link.getAttribute("href") !== href) link.setAttribute("href", href);
  }, [theme]);

  return null;
}
